import { render, staticRenderFns } from "./TabRedactors.vue?vue&type=template&id=246b7d20&"
import script from "./TabRedactors.vue?vue&type=script&lang=js&"
export * from "./TabRedactors.vue?vue&type=script&lang=js&"
import style0 from "./TabRedactors.vue?vue&type=style&index=0&id=246b7d20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports